module.exports = __webpack_public_path__ + "img/icon2.f3199303.png";